import { PlanogramWidget } from "../Widgets/PlanogramWidget"
export const Planogram = () => {
    return (
        <>
            <PlanogramWidget />
        </>
    )
}